import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

const NavigationItem = ({ link, isSelected, label }) => (
    <li className="rn-secondaryNav__list__item">
        <Link
            to={link}
            className={
                `rn-secondaryNav__list__link ui-link
                ${isSelected ? 'ui-link_marked' : ''}`
            }
        >
            {label}
        </Link>
    </li>
);

NavigationItem.propTypes = {
    link: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    isSelected: PropTypes.bool.isRequired,
};

export default NavigationItem;



// WEBPACK FOOTER //
// ./src/js/secondaryNavigation/NavigationItem.jsx